import { ERROR_MESSAGE } from "../constants";

export const cancelOrderValidation = (props: any): any => {
  let formErrors: any = {};
  let formValid: any = true;

  const { remarks } = props;

  if (!remarks || !remarks.trim()) {
    formErrors.remarks = ERROR_MESSAGE.REMARKS_REQUIRED;
    formValid = false;
  }

  return { formValid, formErrors };
};
